"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ReactHeadline01 = function ReactHeadline01(_ref) {
  var text = _ref.text,
      variant = _ref.variant;

  if (!text) {
    return null;
  }

  var headlineSize = "h" + (variant ? variant + 1 : 1);
  return /*#__PURE__*/_react.default.createElement(_Typography.default, {
    className: "mco-headline",
    color: "primary",
    dangerouslySetInnerHTML: {
      __html: text
    },
    variant: headlineSize
  });
};

ReactHeadline01.propTypes = {
  text: _propTypes.default.string.isRequired,
  variant: _propTypes.default.number
};
var _default = ReactHeadline01;
exports.default = _default;